// StreamProvider.tsx
import { useEffect, useRef } from 'react';
import { StreamContext } from './StreamContext';
import { useAppDispatch } from 'hooks/useStore';
import { streamMessage, createThread } from 'store/quizAgent/quizAgentAsync';

export const StreamProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useAppDispatch();
  const streamRef = useRef<any>(null);
  const threadRef = useRef<any>(null);

  const startStream = (data: { threadId: string; message: string; draftQuiz?: any }) => {
    streamRef.current?.abort?.();

    const promise = dispatch(streamMessage(data));
    streamRef.current = promise;
  };

  const abortStream = () => {
    streamRef.current?.abort?.();
    streamRef.current = null;
  };

  const startThread = (data: { quizId?: string; quizType?: string; draftQuiz?: any }) => {
    threadRef.current?.abort?.();

    const promise = dispatch(createThread(data));
    threadRef.current = promise;
    return promise;
  };

  const abortThread = () => {
    threadRef.current?.abort?.();
    threadRef.current = null;
  };

  useEffect(() => {
    return () => {
      abortStream();
      abortThread();
    };
  }, []);

  return (
    <StreamContext.Provider value={{ startStream, abortStream, startThread }}>
      {children}
    </StreamContext.Provider>
  );
};
